import { required } from 'vuelidate/lib/validators';
import { selectionModel, selectionModelCont } from '@/app/utils/toolkit/business-rules/inv-strat-review/reviewReasons';

const mStep = {
  title: 'Last Review',
  description: 'Please provide details on the last investment strategy review.',
};

export default {
  name: 'inv-strat-review-last-review',
  data: () => ({
    mStep,
  }),
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    date: {
      get() {
        if (this.getItem.lastReview.date !== '') {
          this.$v.$touch();
        }
        return this.getItem.lastReview.date;
      },
      set(value) {
        this.setItem({ lastReview: { date: value } });
      },
    },
    type: {
      get() {
        return this.getItem.review.type;
      },
      set(value) {
        this.setItem({
          review: {
            type: value,
            normal: { hasAcknowledge: false },
            specific: {
              reasons: selectionModel(),
              sectionReasons: selectionModelCont(),
              otherReason: { hasOtherReason: '', otherReasons: [] },
            },
          },
          nextReview: { type: undefined },
        });
      },
    },
  },
  methods: {
    setItem(item) {
      this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
  },
  validations: {
    type: {
      required,
    },
    date: {
      required,
      ltToday: value => new Date(value) < new Date(),
    },
  },
};
